import React, { useState, useEffect } from "react";
import { useTracking } from '@rehrig/tracking-sdk';
import { trackLogout } from '../../utils/trackingUtils';
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  ButtonBase,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack
} from "@mui/material";
//import { getUserRole} from "../../diot/redux/Thunk/RoutesThunk";
import {  bellIcon } from "../../diot/assets"
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircleIcon from "@mui/icons-material/Circle";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { connect } from "react-redux";
import ErrorIcon from "@mui/icons-material/Error";
import moment from 'moment';


// import { useAuthenticator } from "@aws-amplify/ui-react";


import { AppLogo, RehrigLogo } from "../../assets";
//import { LicenseInfo } from '@mui/x-license';
import {
    qcBotItems,
    loadValidationItems,
    warehouseInsightItems,
    deliveryInsights, expressDeliveryItems,
} from "./consts/navListItems";
import { checkAccess } from "../../redux/Thunk/AuthThunk";
import {getCentralAdminId, getToken, getUserDetails, openNewURLAMI} from "../../redux/Thunk/WarehouseInsightsThunk"
import { getAlertsForLocation, getRouteByIdData, getHeartBeatsByIdData } from "../../diot/redux/Thunk/RoutesThunk"
import {
  setPageSubTitle,
  setPageChildTitle,
  setVorReferenceNumber,
  setCustomers,
  setSelectedCustomer,
  setSelectedDistributionCenter,
  setLoadingPalletsData,
  setPalletsData,
  // setLoadingPalletsDetails,
  setPalletInferenceID,
  setPalletDetails,
  //setGoBackToPalletReview
  setStartRefresh, setStopScanPallet
} from "../../redux/reducers/palletReview/PalletReviewReducer";
import {
  setPalletArchiveData,
  setLoadingPalletsArchiveData,
} from "../../redux/reducers/palletArchive/PalletArchiveReducer";

import {
    setStartDockDoorRefresh,
} from "../../redux/reducers/dockDoorControl/DockDoorControlReducer";

import {
  resetEmbedURL
} from "../../redux/reducers/warehouseInsights/WarehouseInsightsReducer"

import {SESSION_KEY, isMobile, isTabletDevice} from "../Common/helpers";
import Cookies from "js-cookie";
import {Constants} from "../../utils/Constants";
import ShowModal from "../Common/PermissionModal";
import {LicenseInfo} from "@mui/x-license";
import LoadingBar from "../Common/LoadingBar";
import {getUserRole} from "../../diot/redux/Thunk/RoutesThunk";
import CloseIcon from "@mui/icons-material/Close";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {DataGrid} from "@mui/x-data-grid";
import {GlobalConstants} from "../../utils/GlobalConstants";
import {getFeedbackUrl} from "../../utils/feedbackConfig";
import {PalletData} from "../../utils/PalletData";
import {DataGridPro, getGridStringOperators, GridToolbar} from "@mui/x-data-grid-pro";
import useOrientation from "../Common/DeviceOrientation";
const drawerWidth = 240;
let bredcrumWidth = "500px";



const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(3),
        paddingLeft: isMobile()?1:theme.spacing(3),
        paddingRight: isMobile()?1:theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
        zIndex: (isMobile()?999:""),
      marginLeft: isTabletDevice()?0:`-${drawerWidth - 45}px`,
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
      },

      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

function SideNavDrawer({
                         children,
                         checkAccessFromProps,
                         getAlertsForLocation,
                         getRouteByIdData,
                         getHeartBeatsByIdData,
                         locationAlertsDataLoad,
                         locationAlertsData,
                         palletDetailsFromProps,
                         pageChildTitleFromProps,
                         pageSubTitleFromProps,
                         setPageChildTitleFromProps,
                         setPageSubTitleFromProps,
                         setVorReferenceNumberFromProps,
                         setCustomersFromProps,
                         setSelectedCustomerFromProps,
                         setSelectedDistributionCenterFromProps,
                         setLoadingPalletsDataFromProps,
                         setPalletsDataFromProps,
                         setPalletInferenceIDFromProps,
                         setPalletDetailsFromProps,
                         setPalletArchiveDataFromProps,
                         setLoadingPalletsArchiveDataFromProps,
                         setStartRefreshFromProps,
                         setStartDockDoorRefreshFromProps,
                         setResetEmbedURLFromProps, getUserDetails,

                         setOpenNewURLAMI,
                         getUserRole,
                         selectedCustomerListData,
                         selectedLocationListData,
                         isStopScanPalletFromProps,
                         setStartStopScanPalletFromProps
                       }) {
  const theme = useTheme();
  let navigate = useNavigate();
  // flushTracking is now handled via trackLogout utility
  let location = useLocation();
  const [open, setOpen] = useState(true);
  const [isQcBotCollapse, setIsQcBotCollapse] = useState(true);
  const [isLoadValidationCollapse, setIsLoadValidationCollapse] =
      useState(true);
    const [isExpressDeliveryCollapse, setIsExpressDeliveryCollapse] =
        useState(true);

  const [isWarehouseInsightsCollapse, setIsWarehouseInsightsCollapse] =
      useState(true);
  const [isDeliveryInsightsCollapse, setIsDeliveryeInsightsCollapse] =
      useState(true);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [pageGroupName, setPageGroupName] = useState("QC Bot");
  const [pageTitle, setPageTitle] = useState("Pallet Review");

  const [qcBotVisible,setQCBotVisible] = useState(false);
  const [lvVisible,setLVVisible] = useState(false);
    const [expressVisible,setExpressVisible] = useState(false);

  const [skVisible,setSKVisible] = useState(false);
  const [diVisible,setDIVisible] = useState(false);
  const [amVisible,setAMVisible] = useState(false);
  const [isUserPermisisons,setUserPermissions] = useState(true);
  const [isProgess,setProgress] = useState(false)


  const [pageTitle2, setPageTitle2] = useState("");
  const [pageBreadCrum, setPageBreadCrum] = useState("");
  const [isShowTitle,setIsShowTitle] = useState(false);
  const [routeDetailsTitle,setRouteDetailsTitle] = useState("");
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

    const [diotustomer, setDIOTCustomer] = useState("");
    const [diotLocation, setDIOTLocation] = useState("");

    //let storedCustomer = null;//JSON.parse(localStorage.getItem("selectedCustomer"));
    //let storedLocation = null;//JSON.parse(localStorage.getItem("selectedLocation"));

    let orientation = useOrientation();

  const filterOperators = getGridStringOperators().filter(({ value }) =>
      ["contains" /* add more over time */].includes(value)
  );
  const [filterModel, setFilterModel] = useState({
    items: [
      {
        field: "rating",
        operator: ">",
        value: "2.5",
      },
    ],
  });



  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  // console.log("palletDetailsFromProps", palletDetailsFromProps);
  const handleListItemClick = (e, item) => {
    // Check if any page has registered a navigation guard (e.g. unsaved changes)
    if (window.__navGuardCheck && typeof window.__navGuardCheck === "function") {
      const allowed = window.__navGuardCheck(item.path);
      if (!allowed) return; // Navigation blocked by the guard
    }
    stopAutoRefresh();
    // console.log("handleListItemClick", item.id, item.path, item.name);s
  //  setCookies();
    setPageTitle(item.name);
    setSelectedIndex(item.id);
    setPageGroupName(item.parentText);
    navigate(item.path);
    setPageSubTitleFromProps("");
    setPageChildTitleFromProps("");
    setVorReferenceNumberFromProps("");
    if(isTabletDevice()){
      handleDrawerClose();
    }
      if(isMobile()){
          handleDrawerClose();
    }
  };

  const handleQcBotCollapse = () => {
    setIsQcBotCollapse(!isQcBotCollapse);
  };

  const handleLoadValidationCollapse = () => {
    setIsLoadValidationCollapse(!isLoadValidationCollapse);
  };

    const handleExpressDeliveryCollapse = () => {
        setIsExpressDeliveryCollapse(!isExpressDeliveryCollapse);
    };



  const handleGeneralFeaturesCollapse = () => {
    setIsWarehouseInsightsCollapse(!isWarehouseInsightsCollapse);
  };

  const handleDeliveryCollapse = () => {
    setIsDeliveryeInsightsCollapse(!isDeliveryInsightsCollapse);
  };

  // console.log("location", location.pathname);

  useEffect(()=>{
    // alert(window.screen.width);
    console.log("Side Navigation",location)
    //alert(isTabletDevice())
    //alert(navigator.platform)
    //alert(navigator.maxTouchPoints)
    LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE_KEY);
    getLoginUserDetails();
   // document.addEventListener(Constants.LIFT_MAINTENANCE_EVENT, onLiftMaintenanceSelection);
    //document.addEventListener(Constants.LIFT_ADD_MAINTENANCE_EVENT, onLiftAddMaintenanceSelection);
   // document.addEventListener(Constants.ROUTE_SELECTION_EVENT, onRouteSelection);
    return () => {
      // Unbind the event listener on clean up
     // document.removeEventListener(Constants.ROUTE_SELECTION_EVENT, onRouteSelection);
    }
   // getUserRole()
    },[])



  const columns = [
    {
      field: 'time',
      headerName: 'Date & Time',
      flex: 1,
      renderCell: (params) => {
        const dateobj = moment(params.row.time).format("MMM DD, YYYY hh:mm a");
        return <>{dateobj}</>;
      },
    },
    { field: "liftId", headerName: "Lift ID",width:"150",align:"center",renderHeader: (params) => (
          <span className={"grid-column-header"} style={{width:"250px"}}>
          Lift ID
      </span>

      ) },

    {
      field: 'description',
      headerName: 'Alert Description',
      flex: 1.5,
    },
    {
      field: 'address',
      headerName: ' Alert Address',
      flex: 2,
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      flex: 1,
    },
    {
      field: 'showOnMap',
      headerName: 'Location',
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        // Only offer navigation when the alert is tied to a route.
        if (params.row.localRouteId && params.row.routeName) {
          return (
            <span
              onClick={() => showAlertOnMap(params.row)}
              style={{ cursor: "pointer", color: "#2027A5", textDecoration: "underline" }}
            >
              Show Alert on Map
            </span>
          );
        }
        return <span style={{ color: "#9E9E9E" }}>NA</span>;
      },
    },
  ];

  let getLoginUserDetails = async ()=>{
    let locationPath = location.pathname;
    let isLogin = false;
    if(locationPath == '/' || locationPath == ''){
      isLogin = false;
    }else{
      isLogin = true;
    }
    setProgress(true);
    deliveryInsights.map((item,idx)=>{
      item.visible = false;
    })
    let response = await getUserDetails();
    console.log(response);
    setProgress(false);
    setQCBotVisible(false);
    setDIVisible(false);
    setLVVisible(false);
    setExpressVisible(false);
    setUserPermissions(true);
    if(response && response.payload && response.payload.Data){
      let roleName = response.payload.Data.role_name;
      GlobalConstants.IS_IRIS_UI_VISIBLE = false;
      let applications = response.payload.Data.applications;
      if(roleName == Constants.RPC_ADMIN || roleName == Constants.RPC_READ_ONLY){
        navigateToQCBot(isLogin);
        setNavigationItems(applications,roleName);
        GlobalConstants.IS_IRIS_UI_VISIBLE = true;
      }else{
        if(applications){
          if(applications.indexOf(8)>=0){
            GlobalConstants.IS_IRIS_UI_VISIBLE = true
          }
          setNavigationItems(applications,roleName);
          showUserNavigationMenu(applications,isLogin);
        }
      }

    }
  }

  let setNavigationItems = (apps,roleName)=>{
    deliveryInsights.map((item,idx)=>{
      item.visible = false;
      // DIoT Self-Service Portal is ROLE-gated (not app-gated): show only for the
      // admin roles the RequireRole roles={[1,3,5]} guard permits
      // (RpcAdmin=1 / CustomerAdmin=3 / LocationAdmin=5 per DUO_USER_ROLE).
      // Read-only / user roles are excluded so the nav item never links to a
      // page the guard would redirect.
      if(item.text == "Settings / Alerts"){
        item.visible = (
          roleName == Constants.RPC_ADMIN ||
          roleName == Constants.CUSTOMER_ADMIN ||
          roleName == Constants.LOCATION_ADMIN
        );
        return;
      }
      if(roleName == Constants.RPC_ADMIN || roleName == Constants.RPC_READ_ONLY){
        item.visible = true;
      }else{
        if(apps.indexOf(6)>=0){
          if(item.text == "Assets" || item.text == "Deletion Archive"){
            item.visible = true;

          }
        }if(apps.indexOf(4)>=0){
          if (item.text != "Assets" && item.text != "Deletion Archive"){
            item.visible = true;
          }

        }
      }
    })
    
    // Set EDN visibility based on RPC roles
    expressDeliveryItems.map((item,idx)=>{
      if(item.text == "EDN"){
        if(roleName == Constants.RPC_ADMIN || roleName == Constants.RPC_READ_ONLY){
          item.visible = true;
        }else{
          item.visible = false;
        }
      }
    })

  }

  let navigateToAuditPage = () => {
    let picklistId = "";
    let dcId = "";
    const pathArray = location.pathname.split("/");

    if (pathArray && pathArray.length > 3) {
      picklistId = pathArray[2];
      dcId = pathArray[3];

      // Preserve existing query parameters (e.g. ?inference_id=...)
      const search = location.search || "";

      Constants.isAuditLoaded = false;
      navigate(`/auditpallet/${picklistId}/${dcId}${search}`);
    }
  }

  let navigateToQCBot = (flag)=>{
    setQCBotVisible(true);
    setDIVisible(true);
    setLVVisible(true);
    setSKVisible(true);
    setExpressVisible(true);
    setPageGroupName("QC Bot");
    setPageTitle("Pallet Review");
    if(flag){
      if (location.pathname.includes("/auditpallet")){
        navigateToAuditPage();
      }else{
        // Preserve the query string (and hash) — deep links such as
        // /i/diot/{dc}/{lift}/{stop}?type=...&date=... rely on the search params
        // to route to the correct screen. Navigating to pathname alone dropped
        // ?type=, making the deep-link resolver fall back to lift navigation.
        //
        // TE-2038: forward `state` and replace instead of push. This runs from
        // the mount effect on every full page load, and it targets the URL the
        // user is already on, so pushing a stateless entry here overwrote the
        // history entry's state. Pages that carry their subject in router state
        // (/liftMaintenance and /addMaintenance both read state.liftId) then came
        // up blank on the NEXT reload — the first reload still had the state, and
        // this call destroyed it for the one after. Replacing also stops the
        // duplicate entry that made the back button need two presses.
        navigate(`${location.pathname}${location.search || ""}${location.hash || ""}`, {
          replace: true,
          state: location.state,
        });
      }
    }else{
      navigate("/qcbot");
    }
  }

  let showUserNavigationMenu = (applications,flag)=>{
    let isExist = false;
    let isQcBotExist = false;
    let isLoadValidationExist = false;
      let isExpressDevliveryExist = false;
    let isRouteDBExist = false;
    let isAssetDBExist = false;
    let isWHInsightExist = false;

    if(applications.indexOf(7)>=0 || applications.indexOf(9)>=0 || applications.indexOf(6)>=0 || applications.indexOf(4)>=0 || applications.indexOf(2)>=0 || applications.indexOf(1)>=0){

      if(applications.indexOf(7)>=0){
        isQcBotExist = true;
        setQCBotVisible(true);
      }
      if(applications.indexOf(2)>=0){
        isLoadValidationExist = true;
        setLVVisible(true);
      }
        if(applications.indexOf(9)>=0){
            isExpressDevliveryExist = true;
            setExpressVisible(true);
        }
      if(applications.indexOf(6)>=0 || applications.indexOf(4)>=0 ){
        setDIVisible(true);
        if(applications.indexOf(4)>=0){
          isRouteDBExist = true;
        }
        if(applications.indexOf(6)>=0){
          isAssetDBExist = true;
        }
      }
      if(applications.indexOf(1)>=0){
        isWHInsightExist = true;
        setSKVisible(true)
      }

      if(flag) {
        if (location.pathname.includes("qcbot") || location.pathname.includes("auditpallet") || location.pathname.includes("palletarchive")) {
          if (isQcBotExist) {
            isExist = true;
            if(location.pathname.includes("qcbot")){
              navigate("/qcbot");
            }else if(location.pathname.includes("auditpallet")){
              navigateToAuditPage();
            }else if(location.pathname.includes("palletarchive")){
              navigate("/palletarchive");
            }
          }
        }if(!isExist && location.pathname.includes("dockdoorcontrol")){
          if(isLoadValidationExist){
            isExist = true;
            navigate("/dockdoorcontrol");
          }
        }if(!isExist && location.pathname.includes("edn")){
              if(isExpressDevliveryExist){
                  isExist = true;
                  navigate("/edn");
              }
          }if(!isExist && (location.pathname.includes("operational-performance") || location.pathname.includes("picker-detail") || location.pathname.includes("value-dashboard"))){
          if(isWHInsightExist){
            isExist = true;
            if(location.pathname.includes("operational-performance")){
              navigate("/operational-performance");
            }else if(location.pathname.includes("picker-detail")){
              navigate("/picker-detail");
            }else if(location.pathname.includes("value-dashboard")){
              navigate("/value-dashboard");
            }
          }
        }if(!isExist && (location.pathname.includes("routestatus") || location.pathname.includes("lifts") || location.pathname.includes("casesperhour"))){
            if(isRouteDBExist){
              isExist = true;
              if(location.pathname.includes("routestatus")){
                navigate("/routestatus");
              }else if(location.pathname.includes("lifts")){
                navigate("/lifts");
              }else if(location.pathname.includes("casesperhour")){
                navigate("/casesperhour");
              }
            }
        }if(!isExist && (location.pathname.includes("assets") || location.pathname.includes("deletion-archive"))){
          if(isAssetDBExist){
            if(location.pathname.includes("deletion-archive")){
              navigate("/deletion-archive");
            }else if(location.pathname.includes("assets")){
              navigate("/assets");
            }
          }

        }
      }else{
        if(isQcBotExist){
          navigate("/qcbot");
        }else if (isLoadValidationExist){
          navigate("/dockdoorcontrol");
        }else if (isExpressDevliveryExist){
            navigate("/edn");
        }else if (isWHInsightExist){
          navigate("/operational-performance");
        }else if (isRouteDBExist){
          navigate("/routestatus");
        }else if (isAssetDBExist){
          navigate("/assets");
        }
      }

    }else if((applications.indexOf(5)>=0 || applications.indexOf(3)>=0)){
      setUserPermissions(false);
    }else{
      setUserPermissions(false);
    }
  }

  let resetDefaultValues = ()=>{
    Constants.EXPAND_COLLAPSE_PANEL = false;
    Constants.clearBarcodes();
    Constants.IS_BARCODE_SCANNER_START = false;
    Constants.strPalletId = "";
    setResetEmbedURLFromProps();
    setStartRefreshFromProps(false)
    setStartStopScanPalletFromProps(false)
    PalletData.selectedOperators = "";
    PalletData.selectedWrappers = "";
    PalletData.selectedRoutes = "";

    PalletData.selectedOperatorValues = [];
    PalletData.selectedRouteValues = [];
    PalletData.selectedWrapperValues = [];

    PalletData.isRouteSelected = false;
    PalletData.isOpratorSelected = false;
    PalletData.isWrapperSelected = false;

    console.log( GlobalConstants.SELECTED_PANEL)
    stopScanPallet();

  }

  let resetAssetTabs = ()=>{
    GlobalConstants.SELECTED_PANEL = "";
  }

  useEffect(() => {
   // setCookies();
      let selCustomer = localStorage.getItem("routeDBCustomer");
      if (selCustomer) {
          let storedCustomer = JSON.parse(selCustomer);
          setDIOTCustomer(storedCustomer);
      }
      let selLocation = localStorage.getItem("routeDBLocation");
      if (selLocation) {
          let storedLocation = JSON.parse(selLocation);
          setDIOTLocation(storedLocation);
      }
    bredcrumWidth = "430px";
    if (location.pathname === "/qcbot") {
      setIsShowTitle(false);
      Constants.SCREEN_NAME = Constants.PALLET_REVIEW;
     // Constants.clearBarcodes();
      setSelectedIndex(1);
      setPageGroupName("QC Bot");
      setPageTitle("Pallet Review");
      setStartDockDoorRefreshFromProps(false)
      setResetEmbedURLFromProps()
      setPageChildTitleFromProps("");
      setPageSubTitleFromProps("");
      resetAssetTabs();

      //console.log(pageSubTitleFromProps);
    } else if (location.pathname === "/dockdoorstatus") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(2);
      setPageGroupName("");
      setPageTitle("");
       setPalletDetailsFromProps({})
    //  setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
    // setResetEmbedURLFromProps()
    } else if (location.pathname === "/dockdoorcontrol") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(3);
      setPageGroupName("Load Validation");
      setPageTitle("Dock Door Controls");
      setStartRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
    } else if (location.pathname === "/edn") {
        setIsShowTitle(false);
        setSelectedIndex(12);
        setPageGroupName("Express Delivery");
        setPageTitle("EDN");
        setStartRefreshFromProps(false)
        resetDefaultValues();
        resetAssetTabs();
    } else if (location.pathname === "/value-dashboard") {
        setIsShowTitle(false);
        setSelectedIndex(13);
        setPageGroupName("Warehouse Insights");
        setPageTitle("Value Dashboard");
        setIsWarehouseInsightsCollapse(true);
        setStartRefreshFromProps(false)
        resetDefaultValues();
        resetAssetTabs();
    }else if (location.pathname === "/operational-performance") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(4);
      setPageGroupName("Warehouse Insights");
      setPageTitle("Operational Performance");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
     // setResetEmbedURLFromProps()
    } else if (location.pathname === "/palletarchive") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      Constants.SCREEN_NAME = Constants.PALLET_ARCHIVE;
      setSelectedIndex(5);
      setPageGroupName("QC Bot");
      setPageTitle("Pallet Archive");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      //setResetEmbedURLFromProps()
      setPageSubTitleFromProps("");
      setPageChildTitleFromProps("")
      setPalletDetailsFromProps({})
      resetDefaultValues();
      resetAssetTabs();
    } else if (location.pathname === "/picker-detail") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(6);
      setPageGroupName("Warehouse Insights");
      setPageTitle("Selector Details");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
    }  else if (location.pathname === "/routestatus") {
      //Constants.clearBarcodes();
      setIsShowTitle(true);
       setSelectedIndex(7);
       setPageGroupName("Delivery Insights");
       setPageTitle("Route Status");
      // setStartRefreshFromProps(false)
       setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      // setResetEmbedURLFromProps()
      //setOpenNewURLAMI("routestatus")
    }  else if (location.pathname === "/assets" || location.pathname === "/assets/") {
     // Constants.clearBarcodes();
      setIsShowTitle(true);
      setSelectedIndex(8);
      setPageGroupName("Delivery Insights");
      setPageTitle("Assets");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("assets")
    }  else if (location.pathname === "/deletion-archive") {
      setIsShowTitle(false);
      setSelectedIndex(11);
      setPageGroupName("Delivery Insights");
      setPageTitle("Deletion Archive");
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
    }  else if (location.pathname === "/lifts" || location.pathname === "/liftMaintenance") {
      //Constants.clearBarcodes();
      setIsShowTitle(true);
      setSelectedIndex(9);
      setPageGroupName("Delivery Insights");
      setPageTitle("Lifts");
      setPageSubTitleFromProps("");
      //setPageSubTitleFromProps("Route Details");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
     // setResetEmbedURLFromProps()
      //setOpenNewURLAMI("lifts")
    }  else if (location.pathname === "/casesperhour") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(10);
      setPageGroupName("Delivery Insights");
      setPageTitle("Delivery Performance");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("casesperhour")
    }  else if (location.pathname === "/column-definitions") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(10);
      setPageGroupName("Delivery Insights");
      setPageTitle("Delivery Performance");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("column-definitions")
    }  else if (location.pathname.includes("/i/diot/settings")) {
      // DIoT Self-Service Portal (Settings / Alerts) — id 14 in deliveryInsights.
      // Without this case a reload on the settings route leaves the default
      // (QC Bot / Pallet Review) highlighted.
      setIsShowTitle(false);
      setSelectedIndex(14);
      setPageGroupName("Delivery Insights");
      setPageTitle("Settings / Alerts");
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
    }
    setRouteDetailsTitle("")
    if (location.pathname.includes("/auditpallet")) {
      bredcrumWidth = "500px";
        setSelectedIndex(1);
      setPageSubTitleFromProps("Audit Pallet");
    }else if (location.pathname.includes("/routedetails")) {
        GlobalConstants.IS_ROUTE_DETAILS_LOADING = false;
      bredcrumWidth = "500px";
        setIsShowTitle(true);
        setPageGroupName("Delivery Insights");
        setPageTitle("Route Status");
      setPageSubTitleFromProps("Route Details");
       // resetDefaultValues();
        setSelectedIndex(7);

    }else if (location.pathname.includes("/liftMaintenance")) {
        setSelectedIndex(9);
      bredcrumWidth = "500px";
      setPageSubTitleFromProps("Alerts & Maintenance History");
        setIsShowTitle(true);
    }else if (location.pathname.includes("/addMaintenance")) {
        setSelectedIndex(9);
      bredcrumWidth = "750px";
      setPageChildTitleFromProps("Add Maintenance Record");
        setIsShowTitle(true);
    }


    return () => {

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);


let handleAlertClick = ()=>{
    let selCustomer = localStorage.getItem("routeDBCustomer");
    let storedCustomer = null;
    let storedLocation = null;
    if (selCustomer) {
        storedCustomer = JSON.parse(selCustomer);
    }
    let selLocation = localStorage.getItem("routeDBLocation");
    if (selLocation) {
        storedLocation = JSON.parse(selLocation);
    }
  const customerLocationdata = {
    customerId: storedCustomer?storedCustomer.customerId:selectedCustomerListData.customerId,
    locationId: storedLocation?storedLocation.locationId:selectedLocationListData.locationId,
    date: localStorage.getItem('routeDate'),
  }
  getAlertsForLocation(customerLocationdata)
  setAlertsOpen(true);
}

// Navigate from a Bell-icon alert row to Route Details and plot the alert on the map.
// Mirrors DataMain.routeDetailsPage so RouteDetails receives the same { fromAlert, alertData } state.
let showAlertOnMap = (alertRow) => {
    if (!alertRow) {
        return;
    }
    // The alert must be tied to a route to open Route Details.
    // The location-alerts row exposes the route via localRouteId + routeName.
    const routeId = alertRow.localRouteId;
    const routeName = alertRow.routeName;
    if (!routeId || !routeName) {
        // No route association — nothing to open. Leave the dialog as-is.
        return;
    }

    const routeData = [{ routeId: routeId, routeName: routeName }];
    localStorage.setItem("routeDBRoutes", JSON.stringify(routeData));
    GlobalConstants.IS_ROUTE_DETAILS_LOADING = false;
    GlobalConstants.SELETED_ROUTE_INDEX = 0;
    GlobalConstants.NAVIGATE_ROUTE_DETAILS = true;
    localStorage.setItem("routeIndex", 0);

    getRouteByIdData(routeData);
    getHeartBeatsByIdData(routeData);

    const event = new CustomEvent(Constants.ROUTE_SELECTION_EVENT, { detail: {} });
    document.dispatchEvent(event);

    const navState = {};
    if (alertRow.latitude != null && alertRow.longitude != null) {
        navState.fromAlert = true;
        navState.alertData = {
            id: alertRow.id,
            description: alertRow.description,
            latitude: alertRow.latitude,
            longitude: alertRow.longitude,
            time: alertRow.time,
            liftName: alertRow.liftName || alertRow.liftId,
            address: alertRow.address,
        };
    }

    setAlertsOpen(false);
    navigate('/routedetails', { state: navState });
}

  const handleClose = () => {
    setAlertsOpen(false);
  };
  let stopAutoRefresh = () => {
    const event = new CustomEvent(Constants.ROUTE_DETAILS_BACK_EVENT, { detail: {} });
    document.dispatchEvent(event);
  }
  let stopScanPallet = () => {
    const event = new CustomEvent(Constants.STOP_SCAN_PALLET, { detail: {} });
    document.dispatchEvent(event);
  }

  let onClickSupport = ()=>{
    console.log("Support")
    setSupportOpen(true);
  }

  let handleSupportClose = ()=>{
    setSupportOpen(false);
  }



  return (
      <Box sx={{ display: "flex" }}>{isUserPermisisons?"":<ShowModal />}
        {alertsOpen &&
            <React.Fragment>
              <Dialog
                  open={alertsOpen}
                  onClose={handleClose}
                  sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1000px",  // Set your width here
                      },
                    },
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: "24px" }}>
                  Notifications
                  <IconButton style={{ float: "right" }}>
                    <CloseIcon onClick={() => handleClose()} />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Box sx={{ width: "100%" }}>
                      <DataGridPro
                                sx={{
                                  height:"600px", width: "100%",
                                  display: "grid", borderColor: "#FFF !important",
                                  gridTemplateRows: "auto 1f auto",
                                  cursor: "pointer",
                                  "&, [class^=MuiDataGrid]": { border: "none" },
                                  "& .MuiDataGrid-cell": {
                                    border: 1,
                                    borderRight: 0,
                                    borderTop: 0,
                                    borderLeft: 0,
                                    borderColor: "#D4DFE8",
                                  },
                                  '& .MuiDataGrid-sortIcon': {
                                    opacity: 0,
                                  },
                                }}
                                rows={locationAlertsDataLoad ? [] : locationAlertsData}
                                getRowId={(row) => row.seqNumber}
                                columns={columns}
                                loading={locationAlertsDataLoad}
                                pageSizeOptions={[50, 100,500, 1000]}
                                pagination={true}
                                paginationMode="client"
                                sortingMode="client"
                                filterMode="client"
                                slots={{
                                  toolbar: GridToolbar,
                                  noResultsOverlay: () => (
                                      <Box
                                          sx={{
                                            display: "flex", height: "100%", justifyContent: "center",
                                            alignItems: "center", flexDirection: "column",
                                          }}>
                                        <Typography style={{fontWeight:"400", fontSize:"16px"}}>
                                          No Results Found
                                        </Typography>

                                      </Box>
                                  ),
                                  noRowsOverlay:() => (
                                      <Box
                                          sx={{
                                            display: "flex", height: "100%", justifyContent: "center",
                                            alignItems: "center", flexDirection: "column",
                                          }}>
                                        <Typography style={{fontWeight:"400", fontSize:"16px"}}>
                                          No Rows
                                        </Typography>
                                      </Box>
                                  ),
                                }}
                                slotProps={{
                                  toolbar: {
                                    showQuickFilter: true,
                                  },
                                }}
                                initialState={{
                                  pagination: { paginationModel: { pageSize: 100 } },
                                }}
                                disableRowSelectionOnClick
                                filterModel={filterModel}
                                onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                      />
                    </Box>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </React.Fragment>
        }
        {supportOpen &&
            <React.Fragment>
              <Dialog
                  open={supportOpen}
                  onClose={handleSupportClose}
                  sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "480px",
                        borderRadius: "16px",
                        overflow: "hidden",
                      },
                    },
                  }}
                  aria-labelledby="alert-dialog-title"
              >
                <DialogTitle
                  id="alert-dialog-title"
                  component="div"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "20px 24px",
                    background: "linear-gradient(135deg, #2027A5 0%, #3F51D9 100%)",
                    color: "#FFFFFF",
                  }}
                >
                  <SupportAgentOutlinedIcon sx={{ fontSize: 32 }} />
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography component="h2" sx={{ fontSize: "22px", fontWeight: 600, lineHeight: 1.2 }}>
                      Customer Support
                    </Typography>
                    <Typography sx={{ fontSize: "13px", opacity: 0.85 }}>
                      We're here to help
                    </Typography>
                  </Box>
                  <IconButton
                    aria-label="Close customer support"
                    onClick={handleSupportClose}
                    sx={{ color: "#FFFFFF", "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" } }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent sx={{ padding: "24px !important" }}>
                  <Stack spacing={2}>
                    {[
                      {
                        label: "Business Phone",
                        value: "1-866-742-8232",
                        href: "tel:+18667428232",
                        Icon: PhoneOutlinedIcon,
                      },
                      {
                        label: "Support Email",
                        value: "support@rehrig.com",
                        href: "mailto:support@rehrig.com",
                        Icon: EmailOutlinedIcon,
                      },
                    ].map(({ label, value, href, Icon }) => (
                      <Box key={label} sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <Box
                          sx={{
                            width: 44,
                            height: 44,
                            borderRadius: "50%",
                            backgroundColor: "#EEF0FB",
                            color: "#2027A5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Icon />
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: "12px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {label}
                          </Typography>
                          <Box
                            component="a"
                            href={href}
                            sx={{
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#1F2937",
                              textDecoration: "none",
                              "&:hover": { color: "#2027A5", textDecoration: "underline" },
                            }}
                          >
                            {value}
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Stack>

                  <Divider sx={{ my: 3 }} />

                  <Box
                    component="a"
                    href={getFeedbackUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Tell us about your experience (opens in a new tab)"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      padding: "14px 16px",
                      border: "1px solid #D5D9F5",
                      borderRadius: "12px",
                      backgroundColor: "#F6F7FE",
                      color: "#2027A5",
                      textDecoration: "none",
                      transition: "background-color 0.15s, border-color 0.15s, box-shadow 0.15s",
                      "&:hover": {
                        backgroundColor: "#EEF0FB",
                        borderColor: "#2027A5",
                        boxShadow: "0 2px 8px rgba(32, 39, 165, 0.15)",
                      },
                      "&:focus-visible": {
                        outline: "2px solid #2027A5",
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    <RateReviewOutlinedIcon />
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "inherit" }}>
                        Tell us about your experience
                      </Typography>
                      <Typography sx={{ fontSize: "12px", color: "#6B7280" }}>
                        Share feedback on IRIS
                      </Typography>
                    </Box>
                    <OpenInNewIcon sx={{ fontSize: 20 }} />
                  </Box>
                </DialogContent>
              </Dialog>
            </React.Fragment>
        }
        <AppBar position="fixed" open={open}
            sx={{
              backgroundColor: "#FBFBFB",
              boxShadow: "none",
                // Keep the fixed header above page content on mobile so the
                // breadcrumb links (e.g. "Pallet Review") stay tappable on iOS.
                // The mobile Drawer uses zIndex 9999, so it still overlays the
                // header when open. Previously this was 0, which let content
                // like the audit image viewer (zIndex 1) paint over the header
                // and intercept taps on iPhones.
                zIndex: isMobile()?1100:"",
            }}
        >
          <Toolbar>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon sx={{color: "black"}}/>
            </IconButton>
            <Box
                sx={{
                  display: (isMobile()? (pageTitle == "Route Status"?"none":"flex"):"flex"),
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
            >
              <Box>
                <Box sx={{textAlign:"center"}}>
                  {isProgess?<LoadingBar /> :""}
                </Box>
                <Breadcrumbs sx={{width:bredcrumWidth}}
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                  <Typography
                      variant="body1"
                      color="#000"
                      sx={{ fontWeight: 700 }}
                  >
                    {pageGroupName}
                  </Typography>
                  <ButtonBase
                      disabled={!pageSubTitleFromProps}
                      onClick={() => {
                        stopAutoRefresh();
                        if(pageTitle == "Lifts") {
                          bredcrumWidth = "430px";
                          navigate("/lifts");
                        }else if(pageTitle == "Pallet Review") {
                          navigate('/qcbot');
                        }else if(pageTitle == "Route Status") {
                            bredcrumWidth = "430px";
                            navigate("/routestatus");
                        }else{
                          bredcrumWidth = "430px";
                          navigate(-1);
                        }

                        setPalletDetailsFromProps({})
                        setPageSubTitleFromProps("");
                        setPageChildTitleFromProps("")
                        setVorReferenceNumberFromProps("");
                      }}
                  >
                    <Typography
                        variant="body1"
                        color={pageSubTitleFromProps ? "#000" : "#000"}
                        sx={{ fontWeight: 700 ,textDecoration:(pageSubTitleFromProps?"underline":"")}}
                    >
                      {pageTitle}
                    </Typography>
                  </ButtonBase>
                  {pageSubTitleFromProps && (
                      <ButtonBase disabled={!pageChildTitleFromProps}
                                  onClick={() => {

                                    console.log(pageChildTitleFromProps)
                                    navigate(-1);
                                    //setPageSubTitleFromProps("");
                                    setPageChildTitleFromProps("")
                                    setVorReferenceNumberFromProps("");
                                  }}
                      >
                          <Typography
                              variant="body1"
                              color={pageChildTitleFromProps ? "#000" : "#000"}
                              sx={{ fontWeight: 700,textDecoration:(pageChildTitleFromProps?"underline":"") }}
                          >
                            {pageSubTitleFromProps}
                          </Typography>
                      </ButtonBase>

                  )}
                  {pageChildTitleFromProps && (
                      <Typography
                          variant="body1"
                          color="#58595B"
                          sx={{ fontWeight: 700 }}
                      >
                        {pageChildTitleFromProps}
                      </Typography>

                  )}
                </Breadcrumbs>

                {location.pathname !== "/vor-gpt" && (
                    <>
                      {pageSubTitleFromProps ? (
                          <>
                            <Box sx={{ mt: "8px" ,}} />
                            <Box sx={{display:"flex"}}>
                            <Typography variant="h2" color="#58595B" style={{display: (isShowTitle?"none":"flex")}}>
                              {palletDetailsFromProps?.store_name} - Pallet&nbsp;
                              {palletDetailsFromProps?.customer_picklist_id}
                            </Typography>
                             &nbsp;&nbsp;&nbsp;&nbsp;
                            <Typography variant="h2" color={"#d32f2f"} style={{width:"200px",paddingLeft:"10px",display: (isShowTitle?"none":"flex")}}>
                              {palletDetailsFromProps?.weight_deviation}

                            </Typography>
                            </Box>
                          </>
                      ) : (
                          <>
                            <Box sx={{ mt: "8px",display:"none" }} />
                            <Typography variant="h5" color="#58595B" sx={{display:"none"}}>
                              {pageTitle}
                            </Typography>
                          </>
                      )}
                    </>
                )}
              </Box>
              {pageSubTitleFromProps && (
                  <Box
                      sx={{
                        display: (isShowTitle?"none":"flex"),
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                  >
                    <Typography
                        variant="body1"
                        color="#58595B"
                        align="right"
                        sx={{ fontWeight: 400 }}
                    >
                      {palletDetailsFromProps?.customer_picklist_id} -{" "}
                      {palletDetailsFromProps?.operator_name}
                    </Typography>
                    {palletDetailsFromProps?.contains_un_trained_sku && (
                        <Chip
                            icon={<ErrorIcon />}
                            variant="outlined"
                            color={"error"}
                            label={
                              <Typography
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "13px",
                                  }}
                              >
                                Contains untrained SKU
                              </Typography>
                            }
                            size="small"
                        />
                    )}
                    {palletDetailsFromProps?.is_irregular_weight && (
                        <Chip
                            icon={<ErrorIcon />}
                            variant="outlined"
                            color={"error"}
                            label={
                              <Typography
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "13px",
                                  }}
                              >
                                Irregular weight, please review
                              </Typography>
                            }
                            size="small"
                        />
                    )}
                    {palletDetailsFromProps?.contains_un_trained_sku &&
                        palletDetailsFromProps?.is_weight_heuristic_applied && (
                            <Chip
                                icon={<ErrorIcon />}
                                variant="outlined"
                                color={"error"}
                                label={
                                  <Typography
                                      sx={{
                                        fontWeight: 400,
                                        fontSize: "13px",
                                      }}
                                  >
                                    Please confirm verified pallet
                                  </Typography>
                                }
                                size="small"
                            />
                        )}
                    {palletDetailsFromProps?.is_system_error === 1 && (
                        <Chip
                            icon={<ErrorIcon />}
                            variant="outlined"
                            color={"error"}
                            label={
                              <Typography
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "13px",
                                  }}
                              >
                                Audit needed due to system error
                              </Typography>
                            }
                            size="small"
                        />
                    )}
                    {palletDetailsFromProps?.is_picker_err !== null && (
                        <Chip
                            variant="outlined"
                            color={"primary"}
                            label={
                              <Typography
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "13px",
                                  }}
                              >
                                Audited
                              </Typography>
                            }
                            size="small"
                            sx={{
                              marginTop: "5px",
                            }}
                        />
                    )}
                  </Box>
              )}
              <Box sx={{ width: "100%", mt: "12px",display:(isShowTitle?"":"none") }}>
                <Grid container>

                  <Grid item xs={10} >
                    <Box style={{ fontSize: "16px", fontWeight: 700 }}  sx={{ ml: open ? .125:9.99 }}>
                      <Stack direction="row" spacing={4}>
                        <Box style={{ color: "#58595B",display:"none" }}>
                          <a style={{ cursor: "pointer", textDecoration: "underline" }} onClick={(e) => {
                            console.log(e.currentTarget.text);
                            stopAutoRefresh();
                            if(e && e.currentTarget && e.currentTarget.text.indexOf("Lifts/")>=0) {
                              navigate("/liftdashboard");
                            }else if(pageTitle2) {
                              navigate(-2);
                            }else{
                              navigate(-1);
                            }
                            //{ state: { routeData: ['date'] } })
                          }}>{pageBreadCrum} </a>  <a style={{ cursor: "pointer", textDecoration: "underline" }} onClick={()=>{
                          navigate(-1);
                          setPageTitle2("");
                          setPageTitle("Alerts & Maintenance History");
                        }}>{pageTitle2}</a>  </Box>
                        {location.pathname !== "/cphdashboard" && (
                            (selectedCustomerListData?selectedCustomerListData.customerName:diotustomer.customerName) && (
                                <Box sx={{color:"#000", display: (isMobile()?"none":"")}}>
                                  {selectedCustomerListData?selectedCustomerListData.customerName:diotustomer.customerName}   -
                                  <span style={{ fontWeight: 600 }}> {selectedLocationListData?selectedLocationListData.locationName:diotLocation.locationName} </span>
                                </Box>
                            )
                        )}
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid item xs={2}>
                    <Box sx={{ textAlign: "right",display: (isMobile()?"none":"") }}>
                      <img src={bellIcon} onClick={() => handleAlertClick()} />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

          </Toolbar>
        </AppBar>
        <Drawer
            sx={{
                marginLeft:(isMobile()?"40px":""),

              zIndex:isMobile()?9999:(isTabletDevice()?1200:""),
              width: isTabletDevice() ? "100%":isMobile()?"100%":drawerWidth,
              [theme.breakpoints.down("md")]: {
                width: 0,
              },
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: isTabletDevice() ? "100%":isMobile()?"100%":drawerWidth,
                boxSizing: "border-box",
              },
            }}
            variant="persistent"
            anchor="left"
            open={open}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
        >
          {/* Close button — sticky at top so it always aligns with the AppBar close area */}
          <Box sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 1,
            py: 2,
            minHeight: '80px',
            bgcolor: 'background.paper',
          }}>
            <IconButton aria-label="logo" onClick={() => navigate("/")}>
              <img src={AppLogo} alt="logo" style={{ marginLeft: "10px" }} />
            </IconButton>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Box>
          <Divider />

          <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
          >
            <Box>
              <List>
                <ListItem
                    disablePadding
                    sx={{display:(qcBotVisible?"block":"none")}}
                    onClick={handleQcBotCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isQcBotCollapse ? <ExpandLessIcon sx={{rotate:"180deg"}} /> : <ExpandLessIcon sx={{rotate:"90deg"}} />}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        QC Bot
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse in={isQcBotCollapse} timeout="auto" unmountOnExit sx={{paddingLeft:"10px",display:(qcBotVisible?"":"none")}}>
                  {qcBotItems.map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{ display: "block" }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: selectedIndex === item.id && "600",
                                }}
                            >
                              {item.text}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>
                <Box sx={{ mt: "10px" }} />
                <ListItem
                    // key={item.text}
                    disablePadding
                    sx={{display: (lvVisible?"block":"none") }}
                    onClick={handleLoadValidationCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px",}}>
                    {isLoadValidationCollapse ? (<ExpandLessIcon sx={{rotate:"180deg"}} />) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}} />
                    )}
                    <ListItemText>

                      <Typography variant="h4" color="#111540">
                        Load Validation
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isLoadValidationCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{paddingLeft:"10px",display: (lvVisible?"":"none") }}
                >
                  {loadValidationItems.map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{ display: "block" }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                             },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: selectedIndex === item.id && "600",
                                  }}
                              >
                                {item.text}
                              </Typography>
                              {item.name === "Dock Door Controls" && (
                                  <CircleIcon
                                      sx={{
                                        fontSize: 10,
                                        color: "red",
                                        marginLeft: "10px",
                                        display:"none"
                                      }}
                                  />
                              )}
                            </Box>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>
                  <Box sx={{ mt: "10px" }} />
                  <ListItem
                      // key={item.text}
                      disablePadding
                      sx={{display: (expressVisible?"block":"none") }}
                      onClick={handleExpressDeliveryCollapse}
                  >
                      <ListItemButton sx={{paddingLeft:"5px",}}>
                          {isExpressDeliveryCollapse ? (<ExpandLessIcon sx={{rotate:"180deg"}} />) : (
                              <ExpandLessIcon sx={{rotate:"90deg"}} />
                          )}
                          <ListItemText>

                              <Typography variant="h4" color="#111540">
                                  Express Delivery
                              </Typography>
                          </ListItemText>

                      </ListItemButton>
                  </ListItem>
                  <Collapse
                      in={isExpressDeliveryCollapse}
                      timeout="auto"
                      unmountOnExit
                      sx={{paddingLeft:"10px",display: (expressVisible?"":"none") }}
                  >
                      {expressDeliveryItems.map((item, index) => (
                          <ListItem
                              key={item.id}
                              disablePadding
                              sx={{ display: "block" }}
                          >
                              <ListItemButton
                                  sx={{
                                      "&.Mui-selected": {
                                          backgroundColor: "#2776CC",
                                          color: "#FFFFFF",
                                      },
                                      "&.MuiListItemButton-root:hover": {
                                          backgroundColor: "#2776CC",
                                          color: "#FFFFFF",
                                      },
                                  }}
                                  selected={selectedIndex === item.id}
                                  onClick={(event) => handleListItemClick(event, item)}
                              >
                                  <ListItemText>
                                      <Box sx={{ display: "flex", alignItems: "center" }}>
                                          <Typography
                                              variant="body2"
                                              sx={{
                                                  fontWeight: selectedIndex === item.id && "600",
                                              }}
                                          >
                                              {item.text}
                                          </Typography>
                                      </Box>
                                  </ListItemText>
                              </ListItemButton>
                          </ListItem>
                      ))}
                  </Collapse>
                <Box sx={{ mt: "10px" }} />
                <ListItem
                    // key={item.text}
                    disablePadding
                    sx={{ display:(skVisible?"block":"none")}}
                    onClick={handleGeneralFeaturesCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isWarehouseInsightsCollapse ? (
                        <ExpandLessIcon sx={{rotate:"180deg"}} />
                    ) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}}/>
                    )}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        Warehouse Insights
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isWarehouseInsightsCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{ paddingLeft:"10px",display:(skVisible?"":"none")}}
                >
                  {warehouseInsightItems.filter((item) => item.visible !== false).map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{
                            selected: {
                              backgroundColor: "red",
                            },
                          }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: selectedIndex === item.id && "600",
                                }}
                            >
                              {item.text}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>

                <Box sx={{ mt: "10px" }} />
                <ListItem
                    // key={item.text}
                    disablePadding
                    sx={{ display:(diVisible?"block":"none")}}
                    onClick={handleDeliveryCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isDeliveryInsightsCollapse ? (
                        <ExpandLessIcon sx={{rotate:"180deg"}} />
                    ) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}} />
                    )}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        Delivery Insights
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isDeliveryInsightsCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{paddingLeft:"10px"}}
                >
                  {deliveryInsights.map((item, index) => (


                      (item.visible ? (<ListItem
                              key={item.id}
                              disablePadding
                              sx={{
                                selected: {
                                  backgroundColor: "red",
                                },

                              }}
                          >
                            <ListItemButton
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#2776CC",
                                    color: "#FFFFFF",
                                  },
                                  "&.MuiListItemButton-root:hover": {
                                    backgroundColor: "#2776CC",
                                    color: "#FFFFFF",
                                  },
                                }}
                                selected={selectedIndex === item.id}
                                onClick={(event) => handleListItemClick(event, item)}
                            >
                              <ListItemText>
                                <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: selectedIndex === item.id && "600",
                                    }}
                                >
                                  {item.text}
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>) : ("")
                      )
                  ))}
                </Collapse>


              </List>
            </Box>
            <Box>
              <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "20px",
                    marginBottom: "10px",
                  }}
              >
                <h5 style={{paddingLeft:"25px",cursor:"pointer",fontWeight:"normal",color:"#2027A5"}} onClick={onClickSupport}><a>Support</a></h5>
                <IconButton
                    onClick={() => {
                      //localStorage.removeItem(SESSION_KEY);
                      navigate("/");
                      setCustomersFromProps({});
                      setSelectedCustomerFromProps({});
                      setSelectedDistributionCenterFromProps({});
                      setLoadingPalletsDataFromProps(false);
                      setPalletsDataFromProps({});
                      setPalletInferenceIDFromProps("");
                      setPalletDetailsFromProps({});
                      setPageSubTitleFromProps("");
                      setPageChildTitleFromProps("");
                      setVorReferenceNumberFromProps("");

                      setPalletArchiveDataFromProps({});
                      setLoadingPalletsArchiveDataFromProps(false);
                     // Constants.SELECT_DATE = null;
                      //localStorage.clear();
                      // 1. trackLogout fires SESSION_END with correct user context
                      // 2. then flushes the batch immediately
                      // 3. then signs out
                      trackLogout().finally(() => {
                        Auth.signOut();
                        setTimeout(()=>{
                          let newloc = window.location.origin;
                          window.location.href = newloc;
                        },1000)
                      });

                    }}
                    aria-label="signOut"
                >
                  <LogoutIcon
                      sx={{
                        color: "#111540",
                      }}
                  />
                </IconButton>
              </Box>
              <Divider />
              <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginY: "20px",
                  }}
              >
                <img src={RehrigLogo} alt="rehrig-logo" />
              </Box>
            </Box>
          </Box>
        </Drawer>

        <Main open={open}>
          {location.pathname !== "/vor-gpt" ? (
              <DrawerHeader />
          ) : (
              <Box sx={{ mt: "0px",zIndex: 9999}} />
          )}
          {children}
        </Main>
      </Box>
  );
}

const sideNavDrawerStateToProps = (state) => {
  return {
    palletDetailsFromProps: state?.palletReview?.palletDetails,
    pageSubTitleFromProps: state?.palletReview?.pageSubTitle,
    pageChildTitleFromProps: state?.palletReview?.pageChildTitle,
    selectedLocationListData: state?.Routes?.selectedLocationListData,
    selectedCustomerListData: state?.Routes?.selectedCustomerListData,
    locationAlertsDataLoad: state?.Routes?.locationAlertsDataLoad,
    locationAlertsData: state?.Routes?.locationAlertsData,
    isStopScanPalletFromProps: state?.palletReview?.isStopScanPallet,
  };
};

const sideNavDrawerDispatchToProps = (dispatch) => {
  return {
    checkAccessFromProps: (value) => dispatch(checkAccess()),
    setPageSubTitleFromProps: (value) => dispatch(setPageSubTitle(value)),
    setPageChildTitleFromProps: (value) => dispatch(setPageChildTitle(value)),
    setVorReferenceNumberFromProps: (data) =>
        dispatch(setVorReferenceNumber(data)),
    setCustomersFromProps: (data) => dispatch(setCustomers(data)),
    setSelectedCustomerFromProps: (data) => dispatch(setSelectedCustomer(data)),

    setSelectedDistributionCenterFromProps: (data) =>
        dispatch(setSelectedDistributionCenter(data)),
    setLoadingPalletsDataFromProps: (data) =>
        dispatch(setLoadingPalletsData(data)),
    setPalletsDataFromProps: (data) => dispatch(setPalletsData(data)),
    setPalletInferenceIDFromProps: (data) =>
        dispatch(setPalletInferenceID(data)),
    setPalletDetailsFromProps: (data) => dispatch(setPalletDetails(data)),

    setPalletArchiveDataFromProps: (data) =>
        dispatch(setPalletArchiveData(data)),
    setLoadingPalletsArchiveDataFromProps: (data) =>
        dispatch(setLoadingPalletsArchiveData(data)),
    setStartRefreshFromProps: (value) => dispatch(setStartRefresh(value)),
    setStartDockDoorRefreshFromProps: (value) => dispatch(setStartDockDoorRefresh(value)),
    setResetEmbedURLFromProps: () => dispatch(resetEmbedURL()),
    setOpenNewURLAMI: (value) => dispatch(openNewURLAMI(value)),
    getUserDetails: (value) => dispatch(getUserDetails(value)),
    getAlertsForLocation: (customerLocationdata) => dispatch(getAlertsForLocation(customerLocationdata)),
    getRouteByIdData: (routeData) => dispatch(getRouteByIdData(routeData)),
    getHeartBeatsByIdData: (routeData) => dispatch(getHeartBeatsByIdData(routeData)),
    setStartStopScanPalletFromProps: (value) => dispatch(setStopScanPallet(value)),
    //getUserRole: () => dispatch(getUserRole())
  };
};

export default connect(
    sideNavDrawerStateToProps,
    sideNavDrawerDispatchToProps
)(SideNavDrawer);


